<script setup lang="ts">
import { ref } from 'vue'

const dark = ref(document.documentElement.dataset.theme === 'dark')

function toggle() {
  dark.value = !dark.value
  const t = dark.value ? 'dark' : 'light'
  document.documentElement.dataset.theme = t
  localStorage.setItem('ipo_theme', t)
}
</script>

<template>
  <button class="theme-toggle" :title="dark ? '切換淺色模式' : '切換深色模式'" @click="toggle">
    {{ dark ? '🌙' : '☀️' }}
  </button>
</template>

<style scoped>
.theme-toggle {
  width: var(--control-h);
  height: var(--control-h);
  border: 1px solid var(--border-strong);
  border-radius: var(--r-sm);
  background: var(--bg-panel);
  color: var(--fg-2);
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
}
.theme-toggle:hover {
  background: var(--bg-hover);
}
</style>
